import IconChevronDown from '@apollo/icons/default/IconChevronDown.svg';
import { Card, CardBody } from '@apollo/orbit';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useCallback, useState } from 'react';

import { Timestamp } from 'src/lib/graphqlTypes/customScalarTypes';

import { ErroredTracesListWithData } from '../ErroredTracesListWithData';

export function ErroredPathItem({
  path,
  requestsWithErrorsCount,
  serviceId,
  timeFrom,
  timeTo,
  queryId,
  initiallyExpanded,
}: {
  path: string | null | undefined;
  requestsWithErrorsCount: number;
  serviceId: string;
  timeFrom: Timestamp['output'];
  timeTo: Timestamp['output'];
  queryId: string | undefined;
  initiallyExpanded: boolean | undefined;
}) {
  const [isExpanded, setIsExpanded] = useState(!!initiallyExpanded);
  const toggleExpanded = useCallback(() => {
    setIsExpanded((prevState) => !prevState);
  }, []);

  const titleEnding = path
    ? 'while executing path'
    : 'outside the GraphQL context';

  return (
    <Card variant="unstyled">
      <CardBody>
        <div>
          <div
            onClick={toggleExpanded}
            className="-mx-3 flex h-8 cursor-pointer items-center rounded px-3 hover:bg-primary"
          >
            <IconChevronDown
              className="mr-2 block text-secondary"
              style={{ transform: isExpanded ? 'none' : 'rotate(-90deg)' }}
            />
            <span className="mr-1 text-error">
              <b>{requestsWithErrorsCount.toLocaleString()}</b> operations
              failed
            </span>
            {titleEnding}
            <b className="ml-1 break-all">{path}</b>
          </div>
          <AnimatePresence>
            {isExpanded && (
              <motion.div
                initial={{
                  opacity: 0,
                  height: 0,
                }}
                animate={{
                  opacity: 1,
                  height: 'auto',
                }}
                exit={{
                  opacity: 0,
                  height: 0,
                }}
                transition={{ duration: 0.15 }}
              >
                <ErroredTracesListWithData
                  path={path}
                  requestsWithErrorsCount={requestsWithErrorsCount}
                  serviceId={serviceId}
                  timeFrom={timeFrom}
                  timeTo={timeTo}
                  queryId={queryId}
                />
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </CardBody>
    </Card>
  );
}
